import Input from '@mui/material/Input';
import clsx from 'clsx';
import ConsultSpecialProductBtn, { VARIANT_LIST } from 'components-v2/ui/ConsultSpecialProductBtn';
import useCartControl from 'hooks/useCartControl';
import { useProductConsultation } from 'hooks/useProductConsultation';
import { useEffect, useState } from 'react';
import useCartQuantity from 'zustand-lib/useCartQuantity';
import styles from './styles.module.css';
export default function QuantityControl({ product, className = '', onMinus, onChange, onAdd }) {
  const { displayPrice, pointMultiplier, point, isPointDisabled } = product;
  const { setScore, count } = useCartQuantity((state) => state);
  const [valueCount, setValueCount] = useState(0);
  const [handleIncrease, handleBlurInput, handleChangeInput, handleDecrease] = useCartControl(product);
  const { shouldShowConsultButton } = useProductConsultation();

  const calculatedScore = (number) => {
    // sku bi tat tich diem: khong ap dung ca quy tac mac dinh theo gia.
    // Tra ve '0' vi day la gia tri cac man dung de an han diem (score !== '0'),
    // tra ve '' hay 0 se lam UI hien " diem" / "0 diem".
    if (isPointDisabled) {
      return '0';
    }
    if (point) {
      return number * point * (pointMultiplier || 1);
    }
    if (pointMultiplier) {
      const price = (number * displayPrice * pointMultiplier) / 100000;
      return price > 0 ? price.toFixed(2).toString().replace('.', ',') : '0';
    }
    const price = (number * displayPrice) / 100000;
    return price > 0 ? price.toFixed(2).toString().replace('.', ',') : '0';
  };

  useEffect(() => {
    const score = calculatedScore(count);
    setValueCount(count);
    setScore(score);
  }, [count]);

  if (shouldShowConsultButton(product)) {
    return <ConsultSpecialProductBtn className="qty-control-consult-btn" product={product} variant={VARIANT_LIST.DETAIL} />;
  }

  return (
    <div className={clsx(styles.container, className, 'qty-control-wrapper')}>
      <div
        onClick={(e) => {
          handleDecrease(e);
          onMinus?.(e);
        }}
        className={clsx(styles.minusContainer, 'qty-control-minus')}
        role="button"
      >
        <div className={styles.minus} />
      </div>

      <Input
        className="qty-control-input"
        name="inputNumber"
        value={valueCount}
        onBlur={handleBlurInput}
        onChange={(e) => {
          handleChangeInput(e);
          onChange?.(e);
        }}
        type="number"
        disableUnderline
      />

      <div
        onClick={(e) => {
          handleIncrease(e);
          onAdd?.(e);
        }}
        className={clsx(styles.addContainer, count >= product?.consumedMaxQuantity?.maxQuantityConsumed && styles.disabled, 'qty-control-plus')}
        role="button"
      >
        <div className={styles.addIcon} />
      </div>
    </div>
  );
}

